module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_9_1.888129b1.png";